import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  setDoc,
  SnapshotOptions,
  WithFieldValue,
} from 'firebase/firestore';
import { firestore } from '@/lib/firebase';
import { TV_CONTROLLER_COLLECTION, TvController } from '../schema/tvController';
import {
  useCollectionData,
  useDocumentData,
} from 'react-firebase-hooks/firestore';

// create a tv controller
export async function createTvController(tvController: TvController) {
  await addDoc(collection(firestore, TV_CONTROLLER_COLLECTION), tvController);
}

// update tv controller
export async function updateTvController(
  id: string,
  tvController: Partial<TvController>
) {
  delete tvController.id;

  await setDoc(
    doc(firestore, TV_CONTROLLER_COLLECTION, id),
    { ...tvController },
    {
      merge: true,
    }
  );
}

// hard delete a tv controller
export async function deleteTvController(id: string) {
  await deleteDoc(doc(firestore, TV_CONTROLLER_COLLECTION, id));
}

const taskExecutionConverter: FirestoreDataConverter<TvController> = {
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): any {
    const data = snapshot.data(options);
    return {
      ...data,
      id: snapshot.id,
    } as TvController;
  },
  toFirestore: function (): WithFieldValue<DocumentData> {
    throw new Error('Function not implemented.');
  },
};

// list all tv controllers
export function useTvControllers() {
  return useCollectionData(
    collection(firestore, TV_CONTROLLER_COLLECTION).withConverter(
      taskExecutionConverter
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: false },
    }
  );
}

export function useTvController(id?: string): any {
  // Guard: doc() throws on an undefined segment, which would crash the page.
  return useDocumentData(
    id
      ? doc(firestore, TV_CONTROLLER_COLLECTION, id).withConverter(
          taskExecutionConverter
        )
      : undefined,
    {
      snapshotListenOptions: { includeMetadataChanges: false },
    }
  );
}
